import {
  Culture,
  CultureFormValues,
  ListResponse,
  Params,
} from "../types";
import api from "./api";
import { API_ENDPOINTS } from "./endpoints";

const cultureService = {
  // Culture APIs
  async getCultureList(params: Params): Promise<ListResponse<Culture>> {
    try {
      const response = await api.get(API_ENDPOINTS.CULTURES.LIST, {
        params,
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async getCultureById(id: number): Promise<Culture> {
    try {
      const response = await api.get(API_ENDPOINTS.CULTURES.GET_BY_ID(id));
      return response.data.data;
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async createCulture(body: CultureFormValues): Promise<void> {
    try {
      await api.post(API_ENDPOINTS.CULTURES.CREATE, body);
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async updateCulture(id: number, body: CultureFormValues): Promise<void> {
    try {
      await api.patch(API_ENDPOINTS.CULTURES.UPDATE(id), body);
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async deleteCulture(id: number): Promise<void> {
    try {
      await api.delete(API_ENDPOINTS.CULTURES.DELETE(id));
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },

  async uploadImage(body: FormData): Promise<string> {
    try {
      const response = await api.post(API_ENDPOINTS.FILES.UPLOAD, body, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data.data.fileUrl;
    } catch (error: any) {
      throw error.response?.data.message;
    }
  },
};

export default cultureService;
